export default "__VITE_ASSET__JxLsAEGe__"